/**
 * Advanced font loading strategy to eliminate FOUT/FOIT
 * Uses FontFace API for precise control over font loading timing
 */

(function() {
  'use strict';

  if (!('FontFace' in window)) {
    document.documentElement.classList.add('fonts-loaded');
    return;
  }

  const preloadLinks = document.querySelectorAll('link[rel="preload"][as="font"]');
  const fontUrls = {};
  
  preloadLinks.forEach(link => {
    const href = link.href;
    if (href.includes('rules-regular.woff2')) {
      fontUrls.regular = href;
    } else if (href.includes('rules-medium.woff2')) {
      fontUrls.medium = href;
    }
  });

  const criticalFonts = [
    {
      family: 'Rules',
      weight: '400',
      style: 'normal',
      url: fontUrls.regular
    },
    {
      family: 'Rules', 
      weight: '500',
      style: 'normal',
      url: fontUrls.medium
    }
  ].filter(font => font.url);

  const fontPromises = criticalFonts.map(fontConfig => {
    const font = new FontFace(
      fontConfig.family,
      `url(${fontConfig.url}) format('woff2')`,
      {
        weight: fontConfig.weight,
        style: fontConfig.style,
        display: 'optional'
      }
    );

    document.fonts.add(font);
    
    return Promise.race([
      font.load(),
      new Promise((_, reject) => 
        setTimeout(() => reject(new Error('Font load timeout')), 3000)
      )
    ]);
  });

  Promise.allSettled(fontPromises).then(results => {
    const successfulLoads = results.filter(result => result.status === 'fulfilled');
    
    setTimeout(() => {
      if (successfulLoads.length > 0) {
        document.documentElement.classList.add('fonts-loaded');

        document.body.offsetHeight;
      } else {
        document.documentElement.classList.add('fonts-fallback');
      }
    }, 400);
  });

  setTimeout(() => {
    if (!document.documentElement.classList.contains('fonts-loaded')) {
      document.documentElement.classList.add('fonts-fallback');
    }
  }, 3000);

})();
